import {
  MessageEnvelope,
  PaymentInvoiceData,
  invoiceArraySchema,
  isWeb,
} from '@zonofi/common';
import { ButtonPayload, TemplateButtonKeys } from '../types';
import { OrderImportSourceEnum } from '@zonofi/seller-rtk-store';

export const createButtonPropsMap = (
  msgData: any,
  msgCustomerId: string,
  envelope: MessageEnvelope,
  actionOrderId: string,
  message: any,
  formId?: string,
  formAnswerId?: string
): Record<TemplateButtonKeys, MessageEnvelope | ButtonPayload> => ({
  view_order: isWeb()
    ? envelope
    : {
        customerId: msgCustomerId,
        entityId: actionOrderId || msgData?.orderId,
      },
  upload_invoice: {
    customerId: msgCustomerId,
    entityId: String(msgData?.orderId),
  },
  view_invoice: {
    customerId: msgCustomerId,
    entityId:
      Array.isArray(msgData) && msgData?.length > 0
        ? msgData?.[0]?.invoiceId || msgData?.[0]?.id
        : msgData?.invoiceId || msgData?.id,
  },
  view_campaign: {
    customerId: msgCustomerId,
    entityId: msgData?.id || msgData?.campaignId,
  },
  create_order: {
    customerId: msgCustomerId,
    entityId: msgData?.id || message?.campaignId,
  },
  download_invoice: envelope,
  accept_payment: {
    customerId: msgCustomerId,
    entityId: msgData?.paymentTransactionId || msgData?.id,
  },
  reject_payment: envelope,
  review_invoice: {
    customerId: msgCustomerId,
    suggestions: invoiceArraySchema.safeParse(msgData?.invoice).success
      ? (msgData?.invoice as PaymentInvoiceData)?.flatMap((x) =>
          x.isReminder
            ? x.docNumber?.replace(' ', '')?.replace(' ', '').split(',') || []
            : [x.docNumber]
        )
      : [],
  },
  view_dispatch: {
    customerId: msgCustomerId,
    entityId: msgData?.dispatchId,
  },
  view_survey_response: {
    customerId: msgCustomerId,
    entityId: formId,
    formAnswerId,
  },
  view_contact: envelope,
});
